import get from 'lodash.get';
import isEmpty from 'lodash.isempty';

import { TIER_1, TIER_2, CURRENCY_PLACEHOLDER, ASSET_PLACEHOLDER } from '../constants/app';
import { ASSETS_MANIFEST } from '../constants/assets';
import * as Colors from '../attrs/colors';

export const searchFn = (input, option) => {
  const o = get(option, 'search', '');
  const i = isEmpty(input) ? '' : input.trim();

  if (isEmpty(o)) {
    return false;
  }

  const optionName = o.toLowerCase();
  const searchTerm = i.toLowerCase();

  return optionName.indexOf(searchTerm) >= 0;
};

export const isMetricLocked = (tier, userPlans) => {
  const { isUserStandard, isUserAdvanced, isUserProfessional } = userPlans;

  if (isUserAdvanced || isUserProfessional) {
    return false;
  }

  if (isUserStandard) {
    if (tier <= TIER_2) {
      return false;
    }

    return true;
  }

  if (tier <= TIER_1) {
    return false;
  }

  return true;
};

export const makeZoomOptions = (disabled = []) => [
  {
    value: '7',
    label: '7 Days',
    ...(disabled.includes('7') && { disabled: true }),
  },
  {
    value: '14',
    label: '2 Weeks',
    ...(disabled.includes('14') && { disabled: true }),
  },
  {
    value: '30',
    label: '1 Month',
    ...(disabled.includes('30') && { disabled: true }),
  },
  {
    value: '90',
    label: '3 Months',
    ...(disabled.includes('90') && { disabled: true }),
  },
  {
    value: '182',
    label: '6 Months',
    ...(disabled.includes('182') && { disabled: true }),
  },
  {
    value: 'ytd',
    label: 'YTD',
    ...(disabled.includes('ytd') && { disabled: true }),
  },
  {
    value: '365',
    label: '1 Year',
    ...(disabled.includes('365') && { disabled: true }),
  },
  {
    value: '730',
    label: '2 Years',
    ...(disabled.includes('730') && { disabled: true }),
  },
  {
    value: '1095',
    label: '3 Years',
    ...(disabled.includes('1095') && { disabled: true }),
  },
  {
    value: '1825',
    label: '5 Years',
    ...(disabled.includes('1825') && { disabled: true }),
  },
  {
    value: 'all',
    label: 'All',
    ...(disabled.includes('all') && { disabled: true }),
  },
];

export const makeMAvgOptions = (arr = [], unit) =>
  arr.map((item) => ({
    value: `${item}`,
    label: `${item} ${unit}`,
  }));

export const stringSearch = (primaryStr = '', secondaryStr = '') => {
  return primaryStr.toLowerCase().includes(secondaryStr.toLowerCase());
};

export const getCurrentYear = () => new Date().getFullYear();

export const findClosestIdx = (arr = [], v = 0) => {
  if (isEmpty(arr)) {
    return -1;
  }

  const closest = arr.reduce((acc, curr) => {
    return Math.abs(curr - v) < Math.abs(acc - v) ? curr : acc;
  });

  return arr.indexOf(closest);
};

export const triggerResize = () => window.dispatchEvent(new Event('resize'));

export const getAssetManifest = (symbol) => ASSETS_MANIFEST.find((item) => item.symbol === symbol);

export const getAssetColor = (symbol) => {
  const current = getAssetManifest(symbol);

  return get(current, 'color', Colors.BLUE);
};

export const getAssetName = (symbol) => {
  const current = getAssetManifest(symbol);

  return get(current, 'name', symbol);
};

export const formatDescription = (description = '', asset = '', currency = '') => {
  const currencySelector = new RegExp(CURRENCY_PLACEHOLDER, 'g');
  const assetSelector = new RegExp(ASSET_PLACEHOLDER, 'g');

  return description.replace(assetSelector, asset).replace(currencySelector, currency);
};

export const isValidURL = (string = '') => {
  var res = string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
  );

  return res !== null;
};

export const isNumberWithinRange = (value, range = []) => {
  const [start, end] = range;

  if (value >= start && value <= end) {
    return true;
  }

  return false;
};

export const getPopupContainer = (id) => {
  const el = document.getElementById(id);

  if (el) {
    return el;
  }

  return document.body;
};
